import type { ApiTypingsLookup } from "@/api";

export type PreviewHandler<K extends keyof ApiTypingsLookup> = (
  params: ApiTypingsLookup[K]["request"],
) => ApiTypingsLookup[K]["response"];

type UntypedHandler = (params: unknown) => unknown;

const handlers = new Map<string, UntypedHandler>();

export function registerPreviewHandler<K extends keyof ApiTypingsLookup>(
  kind: K,
  handler: PreviewHandler<K>,
): void {
  handlers.set(kind as string, handler as UntypedHandler);
}

export function getPreviewHandler(kind: string): UntypedHandler | undefined {
  return handlers.get(kind);
}

export function __clearPreviewHandlers(): void {
  handlers.clear();
}
